import { Code, ConnectError } from '@bufbuild/connect';

import { debug } from '@/shared/lib';

import { createErrorReportingInterceptor } from './createErrorReportingInterceptor';

const TRACE_ID_HEADER = 'X-Dc-Trace-Id';

const logTraceError = (
  reason: unknown,
  url: string,
  responseHeader?: Headers,
): void => {
  const error = ConnectError.from(reason);

  if (error.code === Code.Canceled) {
    return;
  }

  const traceId =
    error.metadata.get(TRACE_ID_HEADER) ??
    responseHeader?.get(TRACE_ID_HEADER) ??
    '-';

  const httpStatus = /^HTTP (\d{3})$/.exec(error.rawMessage)?.[1];
  const status = httpStatus ?? Code[error.code];

  debug(`${TRACE_ID_HEADER} [${traceId}] POST ${url} ${status}`);
};

export const traceIdInterceptor = createErrorReportingInterceptor(
  (error, request, response) =>
    logTraceError(error, request.url, response?.header),
);
